import { useApi } from './useApi';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { GetChannelSettingsURL, UpdateChannelRateURL } from '../utils/constants';
import { UpdateWeekDaysPriceAPI } from "../utils/constants";

// TypeScript interfaces
export interface ChannelRate {
  type: 'increase_by_amount' | 'decrease_by_amount' | 'increase_by_percent' | 'decrease_by_percent';
  value: string;
}

export interface ChannelSetting {
  id: number;
  name: string;
  rates: ChannelRate[];
}

export interface ChannelSettingsResponse {
  statusCode: number;
  isSuccess: boolean;
  errorMessages: string[];
  totalRecords: number;
  result: ChannelSetting[];
  data: null;
}

export interface UpdateChannelRateRequest {
  id: number;
  rates: ChannelRate[];
}

interface IRequest {
  dateFrom: string;
  dateTo: string;
  propertyIds: number[];
  price: number;
  weekDays: number[];
}


const channelSettings = () => {
  const { apiPrivate } = useApi();
  
  const UpdateWeekDaysPrice = async (body: IRequest) => {
    let response;
    response = await apiPrivate.post(UpdateWeekDaysPriceAPI, body);
    return response;
  };
  // Get channel settings
  const getChannelSettings = async (): Promise<ChannelSettingsResponse> => {
    const response = await apiPrivate.get(GetChannelSettingsURL);
    return response.data;
  };

  // Update channel rate
  const updateChannelRate = async (body: UpdateChannelRateRequest): Promise<any> => {
    const response = await apiPrivate.put(UpdateChannelRateURL, body);
    return response.data;
  };

  // Query hook for getting channel settings
  const useGetChannelSettings = () => {
    return useQuery({
      queryKey: ['channelSettings'],
      queryFn: getChannelSettings,
      staleTime: 5 * 60 * 1000, // 5 minutes
    });
  };

  const useUpdateWeekDaysPrice = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: IRequest) => UpdateWeekDaysPrice(body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['channelSettings'],
      });
      queryClient.invalidateQueries({
        queryKey: ['/api/GetCalendar'],
      });
    }
  });
};
  // Mutation hook for updating channel rate
  const useUpdateChannelRate = ({ 
    onSuccess, 
    onError 
  }: { 
    onSuccess?: (data: any) => void; 
    onError?: (error: any) => void; 
  }) => {
    return useMutation({
      mutationFn: updateChannelRate,
      onSuccess,
      onError,
    });
  };

  return {
    useGetChannelSettings,
    useUpdateChannelRate,
    useUpdateWeekDaysPrice
  };
};

export default channelSettings;
